// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TFC7LAEpuMfpbc {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 3px;
  text-align: center;
}
.TFC7LAEpuMfpbc .cK8800bwr6I7jA {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 18px;
  margin-bottom: var(--ds-space-0, 0);
}
.TFC7LAEpuMfpbc .VoxTArbVKRYzZ7 {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.TFC7LAEpuMfpbc .D2x2EMO_Lu8g9w {
  margin-bottom: var(--ds-space-200, 16px);
}
.TFC7LAEpuMfpbc .D2x2EMO_Lu8g9w .alZJ2W6xZGezeF {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.TFC7LAEpuMfpbc .D2x2EMO_Lu8g9w .Mrb4fTX6ZZJo_Z,
.TFC7LAEpuMfpbc .D2x2EMO_Lu8g9w .Zq5CurrkVYG_ef {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.TFC7LAEpuMfpbc .PJsKOX1YVskW3f {
  margin-bottom: var(--ds-space-200, 16px);
}
.TFC7LAEpuMfpbc .PJsKOX1YVskW3f .mfWLIZms8dFELt {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.TFC7LAEpuMfpbc .hZtFMYdPj8Yq5B {
  display: grid;
  height: 70px;
  padding: var(--ds-space-0, 0) 15px;
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.TFC7LAEpuMfpbc .hZtFMYdPj8Yq5B p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  .TFC7LAEpuMfpbc {
    width: 265px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCard": `TFC7LAEpuMfpbc`,
	"name": `cK8800bwr6I7jA`,
	"info": `VoxTArbVKRYzZ7`,
	"priceContainer": `D2x2EMO_Lu8g9w`,
	"price": `alZJ2W6xZGezeF`,
	"frequency": `Mrb4fTX6ZZJo_Z`,
	"pricingVaries": `Zq5CurrkVYG_ef`,
	"ctaContainer": `PJsKOX1YVskW3f`,
	"currentPlan": `mfWLIZms8dFELt`,
	"enterpriseFooter": `hZtFMYdPj8Yq5B`
};
export default ___CSS_LOADER_EXPORT___;
